import { c as _c } from "react/compiler-runtime";
import { Box, Divider, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import classnames from 'classnames';
import { getTestId } from './panelTestId';
export interface PanelHeaderProps {
  onClose?: () => void;
  onBack?: () => void;
  hideBorder?: boolean;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
  alignTitles?: boolean;
  testIdPrefix?: string;
  fullWidthSubtitle?: boolean;
  closeIconClass?: string;
  closeLabel?: string;
  closeTooltip?: string;
  actionsGap?: string;
}
export const PanelHeader = props => {
  const $ = _c(38);
  const {
    title,
    subtitle,
    actions,
    testIdPrefix,
    onClose,
    onBack,
    hideBorder,
    alignTitles,
    fullWidthSubtitle: t0,
    closeIconClass: t1,
    closeLabel: t2,
    closeTooltip,
    actionsGap: t3
  } = props;
  const fullWidthSubtitle = t0 === undefined ? true : t0;
  const closeIconClass = t1 === undefined ? "material-symbols-close-rounded" : t1;
  const closeLabel = t2 === undefined ? "Close" : t2;
  const actionsGap = t3 === undefined ? "16px" : t3;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      justifyContent: "space-between",
      alignItems: "center",
      gap: "12px",
      padding: "16px 24px"
    };
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  let t5;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      alignItems: "center",
      gap: "12px",
      minWidth: 0
    };
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  let t6;
  if ($[2] !== onBack) {
    t6 = onBack && <IconButton data-testid="header-back-button" onClick={onBack} sx={{
      color: "var(--mui-palette-text-primary)"
    }}><i className="material-symbols-chevron-left-rounded" /></IconButton>;
    $[2] = onBack;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      minWidth: 0
    };
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  let t8;
  if ($[5] !== testIdPrefix || $[6] !== title) {
    t8 = typeof title === "string" ? <Typography variant="h3" data-testid={getTestId(testIdPrefix, "side-panel-title")}>{title}</Typography> : title;
    $[5] = testIdPrefix;
    $[6] = title;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== t8) {
    t9 = <Stack className="flex-1" sx={t7}>{t8}</Stack>;
    $[8] = t8;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== t6 || $[11] !== t9) {
    t10 = <Stack direction="row" className="flex-1" sx={t5}>{t6}{t9}</Stack>;
    $[10] = t6;
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== actionsGap) {
    t11 = {
      alignItems: "center",
      gap: actionsGap
    };
    $[13] = actionsGap;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== closeIconClass || $[16] !== closeLabel || $[17] !== closeTooltip || $[18] !== onClose || $[19] !== testIdPrefix) {
    t12 = onClose && <Tooltip title={closeTooltip ?? ""}><IconButton onClick={onClose} aria-label={closeLabel} data-testid={getTestId(testIdPrefix, "side-panel-close-button")} sx={{
        color: "var(--mui-palette-text-primary)"
      }}><i className={closeIconClass} /></IconButton></Tooltip>;
    $[15] = closeIconClass;
    $[16] = closeLabel;
    $[17] = closeTooltip;
    $[18] = onClose;
    $[19] = testIdPrefix;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== actions || $[22] !== t11 || $[23] !== t12) {
    t13 = <Stack direction="row" sx={t11}>{actions}{t12}</Stack>;
    $[21] = actions;
    $[22] = t11;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t10 || $[26] !== t13) {
    t14 = <Stack direction="row" sx={t4}>{t10}{t13}</Stack>;
    $[25] = t10;
    $[26] = t13;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== alignTitles || $[29] !== fullWidthSubtitle || $[30] !== subtitle) {
    t15 = subtitle && <Box className={classnames([{
      "ml-[24px]": alignTitles,
      "ml-[40px]": !alignTitles,
      "max-w-[580px]": !fullWidthSubtitle
    }, "mb-[20px] mt-[8px] mr-[24px]"])}>{typeof subtitle === "string" ? <Typography variant="body1">{subtitle}</Typography> : subtitle}</Box>;
    $[28] = alignTitles;
    $[29] = fullWidthSubtitle;
    $[30] = subtitle;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== hideBorder) {
    t16 = !hideBorder && <Divider />;
    $[32] = hideBorder;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== t14 || $[35] !== t15 || $[36] !== t16) {
    t17 = <Stack>{t14}{t15}{t16}</Stack>;
    $[34] = t14;
    $[35] = t15;
    $[36] = t16;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  return t17;
};